import { addAltText, bindKeymapWithCommand, escape } from '@atlaskit/editor-common/keymaps';
import { keymap } from '@atlaskit/editor-prosemirror/keymap';
import { closeMediaAltTextMenu, openMediaAltTextMenu } from './commands';
export default function keymapPlugin(schema, editorAnalyticsAPI) {
  var list = {};
  bindKeymapWithCommand(addAltText.common, openMediaAltTextMenu(editorAnalyticsAPI), list);
  bindKeymapWithCommand(escape.common, closeMediaAltTextMenu, list);
  return keymap(list);
}